module.exports = __webpack_public_path__ + "static/media/icon-location.9a85134f.svg";